export const postcardJumbo = {
	name: 'Untitled Jumbo Postcard Template',
	variant: 'design',
	json: {
		width: 3375,
		height: 1875,
		unit: 'px',
		dpi: 300,
		fonts: [],
		pages: [
			{
				id: 'page_1',
				children: [],
				width: 'auto',
				height: 'auto',
				background: 'white',
				bleed: 0,
				custom: {
					name: 'Front',
				},
				duration: 5000,
			},
			{
				id: 'page_2',
				children: [
					{
						id: 'recipientAreaUS',
						type: 'figure',
						name: 'Recipient Area',
						opacity: 1,
						visible: true,
						selectable: false,
						removable: false,
						alwaysOnTop: true,
						showInExport: true,
						x: 2100,
						y: 1020,
						width: 1275,
						height: 855,
						rotation: 0,
						animations: [],
						blurEnabled: false,
						blurRadius: 10,
						brightnessEnabled: false,
						brightness: 0,
						sepiaEnabled: false,
						grayscaleEnabled: false,
						shadowEnabled: false,
						shadowBlur: 5,
						shadowOffsetX: 0,
						shadowOffsetY: 0,
						shadowColor: 'black',
						shadowOpacity: 1,
						draggable: false,
						resizable: false,
						contentEditable: false,
						styleEditable: false,
						subType: 'rect',
						fill: 'rgba(255,255,255,1)',
						dash: [],
						strokeWidth: 0,
						stroke: 'rgba(155,155,155,1)',
						cornerRadius: 0,
					},
					{
						id: 'returnAddressUS',
						type: 'text',
						name: 'Return Address US',
						opacity: 1,
						visible: true,
						selectable: true,
						removable: false,
						alwaysOnTop: false,
						showInExport: true,
						x: 2150,
						y: 935,
						width: 1225,
						height: 85,
						rotation: 0,
						animations: [],
						blurEnabled: false,
						blurRadius: 10,
						brightnessEnabled: false,
						brightness: 0,
						sepiaEnabled: false,
						grayscaleEnabled: false,
						shadowEnabled: false,
						shadowBlur: 4.956586911258956,
						shadowOffsetX: 0,
						shadowOffsetY: 0,
						shadowColor: 'black',
						shadowOpacity: 1,
						draggable: false,
						resizable: false,
						contentEditable: true,
						styleEditable: false,
						text: 'Return Address\nCity, State Zip',
						placeholder: '',
						fontSize: 35,
						fontFamily: 'Roboto',
						fontStyle: 'normal',
						fontWeight: 'normal',
						textDecoration: '',
						fill: 'rgba(74,74,74,1)',
						align: 'left',
						verticalAlign: 'top',
						strokeWidth: 0,
						stroke: 'black',
						lineHeight: 1.2,
						letterSpacing: 0,
						backgroundEnabled: false,
						backgroundColor: '#7ED321',
						backgroundOpacity: 1,
						backgroundCornerRadius: 0.5,
						backgroundPadding: 0.5,
					},
					{
						id: 'recipientAddressUS',
						type: 'text',
						name: 'Recipient Address US',
						opacity: 1,
						visible: true,
						selectable: false,
						removable: false,
						alwaysOnTop: true,
						showInExport: false,
						x: 2395.9459459559453,
						y: 1349.9999999999998,
						width: 900,
						height: 97,
						rotation: 0,
						animations: [],
						blurEnabled: false,
						blurRadius: 0,
						brightnessEnabled: false,
						brightness: 0,
						sepiaEnabled: false,
						grayscaleEnabled: false,
						shadowEnabled: false,
						shadowBlur: 0,
						shadowOffsetX: 0,
						shadowOffsetY: 0,
						shadowColor: 'black',
						shadowOpacity: 1,
						draggable: false,
						resizable: false,
						contentEditable: false,
						styleEditable: false,
						text: 'Firstname Lastname\nCity, State Postalcode',
						placeholder: '',
						fontSize: 40,
						fontFamily: 'Roboto',
						fontStyle: 'normal',
						fontWeight: 'normal',
						textDecoration: '',
						fill: 'rgba(74,74,74,1)',
						align: 'left',
						verticalAlign: 'top',
						strokeWidth: 0,
						stroke: 'black',
						lineHeight: 1.2,
						letterSpacing: 0,
						backgroundEnabled: false,
						backgroundColor: '#7ED321',
						backgroundOpacity: 1,
						backgroundCornerRadius: 0.5,
						backgroundPadding: 0.5,
					},
				],
				width: 'auto',
				height: 'auto',
				background: 'white',
				bleed: 0,
				custom: {
					name: 'Back',
					country: 'US',
				},
				duration: 5000,
			},
			{
				id: 'page_3',
				children: [
					{
						id: 'recipientAreaCA',
						type: 'figure',
						name: 'Recipient Area',
						opacity: 1,
						visible: true,
						selectable: false,
						removable: false,
						alwaysOnTop: true,
						showInExport: true,
						x: 2100,
						y: 0,
						width: 1275,
						height: 1875,
						rotation: 0,
						animations: [],
						blurEnabled: false,
						blurRadius: 10,
						brightnessEnabled: false,
						brightness: 0,
						sepiaEnabled: false,
						grayscaleEnabled: false,
						shadowEnabled: false,
						shadowBlur: 5,
						shadowOffsetX: 0,
						shadowOffsetY: 0,
						shadowColor: 'black',
						shadowOpacity: 1,
						draggable: false,
						resizable: false,
						contentEditable: false,
						styleEditable: false,
						subType: 'rect',
						fill: 'rgba(255,255,255,1)',
						dash: [],
						strokeWidth: 0,
						stroke: 'rgba(155,155,155,1)',
						cornerRadius: 0,
					},
					{
						id: 'returnAreaCA',
						type: 'figure',
						name: 'Sender Area',
						opacity: 1,
						visible: true,
						selectable: false,
						removable: false,
						alwaysOnTop: true,
						showInExport: true,
						x: 0,
						y: 0,
						width: 500,
						height: 300,
						rotation: 0,
						animations: [],
						blurEnabled: false,
						blurRadius: 10,
						brightnessEnabled: false,
						brightness: 0,
						sepiaEnabled: false,
						grayscaleEnabled: false,
						shadowEnabled: false,
						shadowBlur: 5,
						shadowOffsetX: 0,
						shadowOffsetY: 0,
						shadowColor: 'black',
						shadowOpacity: 1,
						draggable: false,
						resizable: false,
						contentEditable: false,
						styleEditable: false,
						subType: 'rect',
						fill: 'rgba(255,255,255,1)',
						dash: [],
						strokeWidth: 0,
						stroke: 'rgba(155,155,155,1)',
						cornerRadius: 0,
					},
					{
						id: 'recipientAddressCA',
						type: 'text',
						name: 'Recipient Address',
						opacity: 1,
						visible: true,
						selectable: false,
						removable: false,
						alwaysOnTop: true,
						showInExport: false,
						x: 2350,
						y: 900,
						width: 800,
						height: 145,
						rotation: 0,
						animations: [],
						blurEnabled: false,
						blurRadius: 10,
						brightnessEnabled: false,
						brightness: 0,
						sepiaEnabled: false,
						grayscaleEnabled: false,
						shadowEnabled: false,
						shadowBlur: 4.956586911258956,
						shadowOffsetX: 0,
						shadowOffsetY: 0,
						shadowColor: 'black',
						shadowOpacity: 1,
						draggable: false,
						resizable: false,
						contentEditable: false,
						styleEditable: false,
						text: 'Recipient Name\nStreet Address\nCity Province Postal Code',
						placeholder: '',
						fontSize: 40,
						fontFamily: 'Roboto',
						fontStyle: 'normal',
						fontWeight: 'normal',
						textDecoration: '',
						fill: 'rgba(74,74,74,1)',
						align: 'left',
						verticalAlign: 'top',
						strokeWidth: 0,
						stroke: 'black',
						lineHeight: 1.2,
						letterSpacing: 0,
						backgroundEnabled: false,
						backgroundColor: '#7ED321',
						backgroundOpacity: 1,
						backgroundCornerRadius: 0.5,
						backgroundPadding: 0.5,
					},
					{
						id: 'returnAddressCA',
						type: 'text',
						name: 'Return Address',
						opacity: 1,
						visible: true,
						selectable: true,
						removable: false,
						alwaysOnTop: true,
						showInExport: true,
						x: 132.6815642458099,
						y: 137.50000000000085,
						width: 300,
						height: 88,
						rotation: 0,
						animations: [],
						blurEnabled: false,
						blurRadius: 10,
						brightnessEnabled: false,
						brightness: 0,
						sepiaEnabled: false,
						grayscaleEnabled: false,
						shadowEnabled: false,
						shadowBlur: 4.956586911258956,
						shadowOffsetX: 0,
						shadowOffsetY: 0,
						shadowColor: 'black',
						shadowOpacity: 1,
						draggable: false,
						resizable: false,
						contentEditable: true,
						styleEditable: false,
						text: 'RETURN TO:\nReturn Address\nCity Province Postal Code',
						placeholder: '',
						fontSize: 24,
						fontFamily: 'Roboto',
						fontStyle: 'normal',
						fontWeight: 'normal',
						textDecoration: '',
						fill: 'rgba(0,0,0,1)',
						align: 'left',
						verticalAlign: 'top',
						strokeWidth: 0,
						stroke: 'black',
						lineHeight: 1.2,
						letterSpacing: 0,
						backgroundEnabled: false,
						backgroundColor: '#7ED321',
						backgroundOpacity: 1,
						backgroundCornerRadius: 0.5,
						backgroundPadding: 0.5,
					},
				],
				width: 'auto',
				height: 'auto',
				background: 'white',
				bleed: 0,
				custom: {
					name: 'Back',
					country: 'CA',
				},
				duration: 5000,
			},
		],
	},
	status: 'draft',
	history: [],
	tags$Category: [],
	tags$General: [
		'0:Medium:Print',
		'0:Distribution:Mail',
		'0:Format:Postcard',
		'0:Layout:Landscape',
		'0:Dimensions:11x6',
	],
	etc: {
		directives: {
			returnAddressCA: {
				text: 'RETURN TO:\n{{user.streetAddress}}\n{{user.city}} {{user.stateProvince}} {{user.postalCode}}',
			},
			returnAddressUS: {
				text: '{{user.streetAddress}}\n{{user.city}}, {{user.stateProvince}} {{user.postalCode}}',
			},
		},
		cfg: {
			global: {
				minPages: 3,
				maxPages: 3,
			},
			customer: {
				minPages: 2,
				maxPages: 2,
			},
			order: {
				countries: ['US', 'CA'],
				itemId: 'postcardJumbo',
			},
			pageOrderIsLocked: true, // Prevent the user from changing the order of the pages
			canBeResized: false,
			showGuides: true,
		},
	},
};

export default postcardJumbo;
